import React from 'react';

export default React.createClass({
    propTypes: {
        data: React.PropTypes.object,
        urls: React.PropTypes.object,
        removeButton: React.PropTypes.bool,
        onRemove: React.PropTypes.func,
        i18n: React.PropTypes.object,
        profilePhotoPlaceholderUrl: React.PropTypes.string
    },
    getInitialState() {
        return {
            loading: false,
            isFriend: this.props.data.Status === 1 || false,
            isPending: this.props.data.Status === 2 || false
        };
    },
    componentWillUnMount() {
        this.serverRequest.abort();
    },
    handleAddFriend() {
        this.setState({
            loading: true
        });

        this.serverRequest = $.get(this.props.urls.request, {
            friendId: this.props.data.SecureId
        }, (result) => {
            setTimeout(() => {
                if (result.Error) {
                    alert(this.props.i18n.error);
                    this.setState({
                        loading: false
                    });
                } else {
                    this.setState({
                        loading: false,
                        isPending: true
                    });
                    console.log('addFriend', result);
                    dataLayer.push({
                        'event': 'add_friend',
                        'friendId': this.props.data.SecureId,
                        'eventCategory': 'friends',
                        'eventAction': 'add',
                        'eventLabel': "",
                    });   
                }
            }, 1000);
        }).fail(() => {
            alert(this.props.i18n.error);
            this.setState({
                loading: false
            });
        });
    },
    handleRemoveFriend(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        if (confirm(`Weet je zeker dat je ${this.props.data.FullName} wilt ontvrienden?`)) {
            this.setState({
                loading: true
            });

            $.get(this.props.urls.remove, {
                targetFriendId: this.props.data.SecureId
            }, (result) => {
                if (result.Error) {
                    alert(this.props.i18n.error);
                    this.setState({
                        loading: false
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                    dataLayer.push({
                        'event': 'remove_friend',
                        'friendId': this.props.data.SecureId,
                        'eventCategory': 'friends',
                        'eventAction': 'remove',
                        'eventLabel': "",
                    });  
                    this.props.onRemove(this.props.data.SecureId);
                }
            }).fail(() => {
                alert(this.props.i18n.error);
                this.setState({
                    loading: false
                });
            });
        }
    },
    renderButton() {
        if (this.state.loading) {
            return (
                <div className="c-button c-button--transparent c-friend__status c-friend__status--ispending">
                    <span>
                        <div className="c-spinner"></div>
                    </span>
                </div>
            )   ;
        } else if (this.props.removeButton) {
            return (
                <div className="c-button c-button--transparent c-friend__status" onClick={this.handleRemoveFriend}>
                    <span>
                        <svg className="c-icon c-icon--remove">
                            <use xlinkHref="#remove" />
                        </svg>
                    </span>
                </div>
            );
        } else if (this.state.isFriend) {
            return (
                <div className="c-button c-button--transparent c-friend__status c-friend__status--isfriend">
                    <span>
                        <svg className="c-button__icon c-icon c-icon--friended">
                            <use xlinkHref="#friended" />
                        </svg>
                        <span className="c-button__text">{this.props.i18n.isFriend}</span>
                    </span>
                </div>
            );
        } else if (this.state.isPending) {
            return (
                <div className="c-button c-button--transparent c-friend__status c-friend__status--ispending">
                    <span>
                        <svg className="c-button__icon c-icon c-icon--pending">
                            <use xlinkHref="#pending" />
                        </svg>
                        <span className="c-button__text">{this.props.i18n.invited}</span>
                    </span>
                </div>
            );
        } else {
            return (
                <div className="c-button c-button--transparent c-friend__status" onClick={this.handleAddFriend}>
                    <span>
                        <svg className="c-button__icon c-icon c-icon--add">
                            <use xlinkHref="#add" />
                        </svg>
                        <span className="c-button__text">{this.props.i18n.add}</span>
                    </span>
                </div>
            );
        }
    },
    render() {
        if (this.state.isFriend) {
            return(
                <div className="c-linkBlock c-friend">
                    <a href={this.props.urls.detail + '?friend=' + this.props.data.SecureId}>
                        <div className="c-linkBlock__wrapper">
                            <div className="c-linkBlock__item">
                                <div className="c-headshot">
                                    <img src={this.props.data.PhotoUrl ? this.props.data.PhotoUrl : this.props.profilePhotoPlaceholderUrl} alt="" />
                                </div>
                            </div>
                            <div className="c-linkBlock__headers">
                                <div className="c-linkBlock__title">{this.props.data.FullName}</div>
                                <div className="c-linkBlock__subtitle">{this.props.data.City}</div>
                            </div>
                            <div className="c-linkBlock__item">
                                {this.renderButton()}
                            </div>
                        </div>
                    </a>
                </div>);
        } else {
            return(
            <div className="c-linkBlock c-friend">
                <div className="c-linkBlock__wrapper">
                    <div className="c-linkBlock__item">
                        <div className="c-headshot">
                            <img src={this.props.data.PhotoUrl ? this.props.data.PhotoUrl : this.props.profilePhotoPlaceholderUrl} alt="" />
                        </div>
                    </div>
                    <div className="c-linkBlock__headers">
                        <div className="c-linkBlock__title">{this.props.data.FullName}</div>
                        <div className="c-linkBlock__subtitle">{this.props.data.City}</div>
                    </div>
                    <div className="c-linkBlock__item">
                        {this.renderButton()}
                    </div>
                </div>
            </div>);
        }
    }
});
